/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import { Close as RadixUIDialogClose } from "@radix-ui/react-dialog";

import type { ThemeType } from "../../../../../global/emotion";
import { spacing } from "../../../../../global/emotion";
import { useIsDesktopViewport } from "../../../../hooks/useIsDesktopViewport";
import { cssMediaQueryMinWidthTablet } from "../../../../lib/constants/emotionMediaQueries.constants";
import { Button } from "../../../_base/_core/Button/Button.emotion";
import { Text } from "../../../_base/_core/Text/Text.emotion";
import { CheckmarkIcon } from "../../../_base/icons/Icon/GeneralIcons";

const rootStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.xl,
  height: spacing.full,
  [cssMediaQueryMinWidthTablet]: { width: "336px" },
};
const contentContainerStyle: Interpolation = {
  alignItems: "center",
  alignText: "center",
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
  textAlign: "center",
};
const iconStyle: Interpolation<ThemeType> = (theme) => ({
  color: theme.semanticColors.successSuccess,
});
const footerMobileStyle: Interpolation<ThemeType> = (theme) => ({
  background: theme.semanticColors.background,
  bottom: 0,
  justifyContent: "center",
  left: 0,
  paddingBottom: spacing.ms,
  paddingInline: spacing.ml,
  position: "fixed",
  width: spacing.full,
});

export const FlagRecordSuccess = () => {
  const isDesktop = useIsDesktopViewport();
  const t = useTranslations();
  return (
    <div css={rootStyle}>
      <div css={contentContainerStyle}>
        <CheckmarkIcon.FilledOn size={72} css={iconStyle} />
        <Text size="xl" type="title">
          {t("community_flag_appreciate_you")}
        </Text>
        <Text>{t("community_flag_report_submitted_successfully")}</Text>
      </div>
      <div css={!isDesktop ? footerMobileStyle : undefined}>
        <RadixUIDialogClose asChild>
          <Button size="l" isFullWidth={true}>
            {t("campaign_report_done")}
          </Button>
        </RadixUIDialogClose>
      </div>
    </div>
  );
};
